import { TextFieldElement } from 'react-hook-form-mui';

export function Comment({ name = 'comment', disabled = false, ...defaultProps }) {
    return <TextFieldElement label="Comment" name={name} id={name} multiline disabled={disabled} {...defaultProps} />;
}
